import { CHECKOUT_STEPS, CheckoutProgressStep } from '..'

export function enableProgressTracker(
  currentStep?: CheckoutProgressStep
): boolean {
  if (!currentStep) return false
  const steps = [...CHECKOUT_STEPS]
  return steps.findIndex(({ label }) => label === currentStep) !== -1
}
